import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { UserSettingsActions } from './user-settings.actions';
import { UserSettingsApiService } from '@app/core/api/user-settings';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class UserSettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly settingsApiService = inject(UserSettingsApiService);
  private readonly logger = inject(LoggerService).scope('UserSettingsEffects');

  loadSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSettingsActions.loadSettings),
      switchMap(() =>
        this.settingsApiService.getSettings().pipe(
          map(settings => UserSettingsActions.loadSettingsSuccess({ settings })),
          catchError(error => {
            this.logger.error('Load settings failed:', error);
            return of(UserSettingsActions.loadSettingsFailure({ error: error.message }));
          })
        )
      )
    )
  );

  updateSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserSettingsActions.updateSettings),
      switchMap(({ data }) =>
        this.settingsApiService.updateSettings(data).pipe(
          map(settings => UserSettingsActions.updateSettingsSuccess({ settings })),
          catchError(error => {
            this.logger.error('Update settings failed:', error);
            return of(UserSettingsActions.updateSettingsFailure({ error: error.message }));
          })
        )
      )
    )
  );
}
